import React, { useState, useEffect, useCallback, useContext } from 'react';
import { TenantContext } from '../../tenant/TenantContext';
import { Row, Col, Table, Button } from 'react-bootstrap';
import { API } from '../../api/API';
import { BUSINESS_PROMOTIONS } from '../../config/config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTruckArrowRight, faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useParams, useNavigate } from 'react-router-dom';
import _ from "lodash";
import { extractError } from '../../api/ErrorUtil';
import { FormContainer } from '../../uiwidgets/FormContainer';
import { FormField } from 'uiwidgets/FormField';
import { getFulfilmentState } from 'util/Lookup';
import { PAGE_SIZE } from '../../config/config';
import { containsAlphaNumAndSpaceAndPunctuationOnly } from 'util/Validators';
import { isEmailAddressValid } from 'util/Validators';


const BusinessPromotionFulfillment = () => {

  const initialState = {
    errors: {},
    infoMessage: ""
  }

  const { businessConfig } = useContext(TenantContext);
  const [promotionFulfilments, setPromotionFulfilments] = useState([]);
  const [formData, setFormData] = useState(initialState);
  const [refresh, setRefresh] = useState(0);
  const requestParams = useParams();

  const [currentPage, setCurrentPage] = useState(0);
  const [totalNumberOfPages, setTotalNumberOfPages] = useState(0);
  const [keyword, setKeyword] = useState("");
  const [filterValidityData, setFilterValidityData] = useState({
    keywordErrMsg: "", keywordError: false,
    statusErrMsg: "", statusError: false
  });
  const [status, setStatus] = useState("");


  const messageReset = () => {
    return {
      infoMessage: "",
      errors: {}
    }
  }

  const onToastClose = () => {
    setFormData({
      ...formData,
      ...messageReset()
    });
  }

  const fetchPromotions = useCallback(async () => {
    try {
      if (!requestParams.promotionId) {
        setFormData({ ...formData, infoMessage: "No promotions were found" });
        return;
      }
      let promotionsResponse = await API.get(BUSINESS_PROMOTIONS + "/promotion-fulfilment/" + requestParams.promotionId, {
        params: {
          size: PAGE_SIZE,
          page: currentPage,
          keyword: keyword.trim(),
          status: status
        }
      });
      let promotions = promotionsResponse.data.content
      let totalNumberOfPages = promotionsResponse.data.totalPages;

      setPromotionFulfilments(promotions);
      setTotalNumberOfPages(totalNumberOfPages);

    } catch (error) {
      let { message, errors, httpStatus } = extractError(error);
      if (httpStatus === 404) {
        setPromotionFulfilments([]);
        setFormData({ ...formData, infoMessage: "No promotions were found" });
      } else {
        setFormData({ ...formData, errors: { message, errors, httpStatus } });
      }
    }

  })

  useEffect(() => {
    fetchPromotions();
  }, []);

  useEffect(() => {
    fetchPromotions();
  }, [refresh]);


  const handlePaging = async (page) => {
    if (page < 0) {
      alert("Reached the beginning of data set")
      page = 0;
    }
    if (page > totalNumberOfPages - 1) {
      alert("Reached the end of data set")
      page = totalNumberOfPages - 1;
    }
    setCurrentPage(page);
    setRefresh(Math.random);
  }

  const handleFilterKeyDown = async (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      setRefresh(Math.random);
    }
  };
  const clearFilter = async (event) => {
    setKeyword("");
    setStatus("");
    setCurrentPage(0);
    setRefresh(Math.random);
  };

  const   handleFilterChange = async (event) => {
    const name = event.target.name;
    const value = event.target.value;
    if (name === 'keyword') {
      setKeyword(value)
    } else if (name === 'status') {
      setStatus(value)
      setRefresh(Math.random);
    }
  }

  const handleFilterValidation = async (event) => {
    const name = event.target.name;
    const value = event.target.value;
    let { hasError, error } = validateInput(name, value);
    setFilterValidityData({
      ...filterValidityData,
      [name + 'Error']: hasError,
      [name + 'ErrMsg']: error
    })
  }


  const validateInput = (name, value) => {
    let hasError = false,
      error = ""

    switch (name) {
      case "keyword":
        if (value.trim() === "") {
          hasError = false
          error = ""
        } else if (!isEmailAddressValid(value)) {
          hasError = true
          error = "Invalid keyword. Only alphanumeric characters are allowed";
        } else {
          hasError = false
          error = ""
        }
        break
      case "status":
        if (value.trim() === "") {
          hasError = false
          error = ""
        } else {
          hasError = false
          error = ""
        }
        break
      default:
        break
    }
    return { hasError, error }
  }

  const fulfilPromotion = async (event, promotionFulfilment) => {
    try {
      let promotionsResponse = await API.put(BUSINESS_PROMOTIONS + "/promotion-fulfilment/" + promotionFulfilment.promotionFulfilmentId + "/shipped");
      setRefresh(Math.random);
    } catch (error) {
      let { message, errors, httpStatus } = extractError(error);
      if (httpStatus === 404) {
        setFormData({ ...formData, infoMessage: "No promotions were found to mark as shipped" });
      } else {
        setFormData({ ...formData, errors: { message, errors, httpStatus } });
      }
    }
  }

  return (
    <FormContainer title="Promotions Fulfilment" toastCloseFunc={onToastClose} errors={formData.errors} infoMessage={formData.infoMessage} >
      <Row>
        <Col>
          {promotionFulfilments && !_.isEmpty(promotionFulfilments) &&
            <>
              {promotionFulfilments[0].promotion.name}<br />
              {promotionFulfilments[0].promotion.description}

            </>
          }
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={4} lg={4}>
          <FormField name="keyword" label="Donor Email" type="text" value={keyword}
            placeholder="email" onChange={handleFilterChange}
            onBlur={handleFilterValidation} onKeyDown={handleFilterKeyDown}
            valstate={!filterValidityData.keywordError} valMsg={filterValidityData.keywordErrMsg} />
        </Col>
        <Col sm={12} md={4} lg={4}>
          <FormField name="status" label="status" type="select" value={status}
            placeholder="status" onChange={handleFilterChange}
            onBlur={handleFilterValidation} onKeyDown={handleFilterKeyDown}
            valstate={!filterValidityData.statusError} valMsg={filterValidityData.statusErrMsg}>
              <option value="" key="0"></option>
              <option value="EMAIL_SENT" key="1">Email Sent to Donor</option>
              <option value="USER_INFO_SUIBMITTED" key="2">User Info Submitted</option>
              <option value="SHIPPED" key="3">Shipped</option>
              </FormField>
        </Col>

        <Col sm={6} md={2} lg={2}>
          <br />
          <Button variant="info" className="border-0 btn-fill" onClick={clearFilter}><strong><small>Clear Filter</small></strong></Button>
        </Col>
      </Row>


      <Row>
        <Col className='d-flex justify-content-end'>
          <Button variant="dark" className="border-0 text-dark" onClick={(event) => { handlePaging(currentPage - 1) }}>
            <h6><FontAwesomeIcon icon={faArrowLeft} onClick={(event) => { handlePaging(currentPage - 1) }} />Previous Page</h6>
          </Button>
          &nbsp;<span className="border-0 text-dark btn"><h6>{currentPage + 1} of {totalNumberOfPages}</h6></span>
          &nbsp;<Button variant="dark" className="border-0 text-dark" onClick={(event) => { handlePaging(currentPage + 1) }}>
            <h6>Next Page<FontAwesomeIcon icon={faArrowRight} /></h6>
          </Button>
        </Col>

      </Row>
      <Table className="table-hover table-striped">
        <thead>
          <tr>
            <th className="border-0">Donor Email Address</th>
            <th className="border-0">User Choices</th>
            <th className="border-0">Shipping Address</th>
            <th className="border-0">Status</th>
            <th className='border-0'>Mark as Shipped</th>
          </tr>

        </thead>
        <tbody>
          {promotionFulfilments && !_.isEmpty(promotionFulfilments) && promotionFulfilments.map((promotionFulfilment, idx) => (
            <tr key={idx}>
              <td>
                {promotionFulfilment.donorEmail}
              </td>
              <td>
                {promotionFulfilment.fulfilmentState != 'EMAIL_SENT' && promotionFulfilment.userChoices?.promotionImage && <>
                  Image Name: {promotionFulfilment.userChoices.promotionImage.imageName}<br />
                  {promotionFulfilment.userChoices.promotionOptions.map((po, idx) => (<React.Fragment key={idx}>
                    {po.optionName}:{po.value}<br />
                    </React.Fragment>))}
                </>}
              </td>
              <td>
                {promotionFulfilment.fulfilmentState != 'EMAIL_SENT' && <>
                  {promotionFulfilment.address}<br />
                  {promotionFulfilment.city},{promotionFulfilment.state},{promotionFulfilment.zip}<br />
                  {promotionFulfilment.country}
                </>}
              </td>
              <td>
                {getFulfilmentState(promotionFulfilment.fulfilmentState)}
              </td>
              <td>
                {promotionFulfilment.fulfilmentState == 'USER_INFO_SUIBMITTED' && <>
                  <Button variant="dark" className="border-0 text-dark" onClick={evt => fulfilPromotion(evt, promotionFulfilment)}>
                    <FontAwesomeIcon icon={faTruckArrowRight} />
                  </Button>
                </>}

              </td>
            </tr>
          ))}

        </tbody>
      </Table>
      {/*promotionFulfilments && JSON.stringify(promotionFulfilments)*/}
    </FormContainer >
  )
}

export default BusinessPromotionFulfillment